/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type EvalSuiteObject = {
  id: string;
  object: "eval.suite";
  name: string;
  description: string | null;
  /**
   * The org that owns this suite.
   */
  orgId: string;
  /**
   * The team that owns this suite.
   */
  teamId: string;
  activeVersion: number;
  latestVersion: number;
  metadata: { [k: string]: string };
  createdAt: number;
  updatedAt: number;
};

/** @internal */
export const EvalSuiteObject$inboundSchema: z.ZodType<
  EvalSuiteObject,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("eval.suite"),
  name: z.string(),
  description: z.nullable(z.string()),
  org_id: z.string(),
  team_id: z.string(),
  active_version: z.number().int(),
  latest_version: z.number().int(),
  metadata: z.record(z.string()),
  created_at: z.number().int(),
  updated_at: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "org_id": "orgId",
    "team_id": "teamId",
    "active_version": "activeVersion",
    "latest_version": "latestVersion",
    "created_at": "createdAt",
    "updated_at": "updatedAt",
  });
});
/** @internal */
export type EvalSuiteObject$Outbound = {
  id: string;
  object: "eval.suite";
  name: string;
  description: string | null;
  org_id: string;
  team_id: string;
  active_version: number;
  latest_version: number;
  metadata: { [k: string]: string };
  created_at: number;
  updated_at: number;
};

/** @internal */
export const EvalSuiteObject$outboundSchema: z.ZodType<
  EvalSuiteObject$Outbound,
  z.ZodTypeDef,
  EvalSuiteObject
> = z.object({
  id: z.string(),
  object: z.literal("eval.suite"),
  name: z.string(),
  description: z.nullable(z.string()),
  orgId: z.string(),
  teamId: z.string(),
  activeVersion: z.number().int(),
  latestVersion: z.number().int(),
  metadata: z.record(z.string()),
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    orgId: "org_id",
    teamId: "team_id",
    activeVersion: "active_version",
    latestVersion: "latest_version",
    createdAt: "created_at",
    updatedAt: "updated_at",
  });
});

export function evalSuiteObjectToJSON(
  evalSuiteObject: EvalSuiteObject,
): string {
  return JSON.stringify(EvalSuiteObject$outboundSchema.parse(evalSuiteObject));
}
export function evalSuiteObjectFromJSON(
  jsonString: string,
): SafeParseResult<EvalSuiteObject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvalSuiteObject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvalSuiteObject' from JSON`,
  );
}
